<template>
  <section class="section" v-bind="$attrs" data-element="Section">
    <div class="section-heading">
      <div class="section-heading__content">
        <div v-if="title || $slots.title" class="section-heading__title">
          <slot name="title">{{ title }}</slot>
        </div>
        <div v-if="description || $slots.description" class="section-heading__description">
          <slot name="description">{{ description }}</slot>
        </div>
      </div>
      <div class="section-heading__actions">
        <slot name="actions" />
      </div>
    </div>
    <div class="section-content">
      <slot />
    </div>
    <div class="section-actions">
      <slot name="actions" />
    </div>
  </section>
</template>

<script setup lang="ts">
  defineProps<{
    title?: string
    description?: string
  }>()
</script>

<style lang="scss" scoped>
  .section {
    @apply flex flex-col gap-12 relative;

    &-heading {
      @apply flex items-center justify-between gap-4;

      &__content {
        @apply flex flex-col flex-1 gap-1;
      }
      &__title {
        @apply font-display font-medium uppercase text-2xl text-black tracking-wider;
      }
      &__description {
        @apply text-base font-medium text-black/75;
      }
      &__actions {
        @apply flex gap-6;
      }
    }
    &-actions {
      @apply hidden;
    }

    @include media("xl") {
      @apply gap-8;

      &-heading {
        &__title {
          @apply text-xl;
        }
        &__description {
          @apply text-sm;
        }
      }
    }
    @include media("lg") {
      @apply gap-6;

      &-heading {
        &__content {
          @apply gap-1;
        }
        &__title {
          @apply text-lg;
        }
        &__description {
          @apply text-sm;
        }
      }
    }
    @include media("sm") {
      @apply gap-4;

      &-heading {
        &__title {
          @apply text-base;
        }
        &__description {
          @apply text-xs;
        }
        &__actions {
          @apply hidden;
        }
      }
      &-actions {
        @apply flex w-full;
      }
    }
  }
</style>
